module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primaerlogo_postale_neg.6d3adcc6.svg";